const LEADING_SLASHES_PATTERN = /^\/+/

export const STATIC_ASSETS_BASE_URL =
  (import.meta.env.VITE_STATIC_ASSETS_BASE_URL || 'https://cdn.wager.games/wager-studio/v1').replace(/\/$/, '')

export function staticAssetUrl(assetPath) {
  const normalized = String(assetPath || '').replace(LEADING_SLASHES_PATTERN, '')
  return `${STATIC_ASSETS_BASE_URL}/${normalized}`
}
